import { ResponseType } from 'axios';
import { HTTP_METHOD } from 'src/constants/api';
import { DTO } from './base.dto';

export interface IRegistrationBodyDTO {
	email: string;
	password: string;
	passwordConfirm: string;
}

export interface IIndividualRegistrationDTO extends IRegistrationBodyDTO {
	fistName: string;
	middleName: string;
	lastName: string;
}

export interface ICoporateRegistrationDTO extends IRegistrationBodyDTO {
	companyName: string;
}

export class RegistrationResponse {
	token?: string;
	otpExpiredAt?: Date;
	constructor(data: { token: string }) {
		this.token = data.token;
	}
}

export class RegistrationDTO extends DTO {
	public param: object | undefined;
	public query: undefined;
	public body: IRegistrationBodyDTO;
	public url: string;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseClass = RegistrationResponse;
	public readonly responseType: ResponseType = 'json';
	constructor(body: IRegistrationBodyDTO, url: string) {
		super();
		this.body = body;
		this.url = url;
	}
}
